<section class="uploader">
  <div class="layout">
    <!--
    <dl class="meta">
<!--      <dt>{{ 'meta.uploadFor' | translate }}</dt>
      <dd>{{ aggregateType() }} {{ aggregateId() }}</dd>
      <!--<dt>{{ 'meta.visibility' | translate }}</dt>
      <dd>{{ visibility() ?? '—' }}</dd>
      <dt>{{ 'meta.position' | translate }}</dt>
      <dd>{{ position() ?? '—' }}</dd>
    </dl>-->

    @if (hasAggregateReference()) {
      @if (configError()) {
        <p class="upload-status upload-status--error" role="alert">
          {{ 'errors.configLoad' | translate }}
        </p>
      }
      <!--
      <div class="tags">
        <label class="tags-label" for="tag-input">{{ 'tags.label' | translate }}</label>
        @if (!isCompleted()) {
          <input
            id="tag-input"
            #tagField
            class="tags-input"
            type="text"
            [placeholder]="'tags.placeholder' | translate"
            [value]="tagDraft()"
            [disabled]="uploadDisabled()"
            (input)="onTagDraftChange(tagField.value)"
            (keydown.enter)="$event.preventDefault(); commitTagDraft()"
            (blur)="commitTagDraft()"
          />
        }

        @if (tags().length) {
          <div class="tags-list">
            @for (tag of tags(); track tag) {
              <claas-chip
                [label]="tag"
                [showCancelButton]="!uploadDisabled() && !isCompleted()"
                [disabled]="uploadDisabled()"
                (onRemoved)="removeTag(tag)"
              ></claas-chip>
            }
          </div>
        }
      </div>
-->
      <sap-file-uploader
        [maxUploadSize]="maxTotalSize()"
        [maxFiles]="maxFiles()"
        [allowedFileTypes]="allowedFileTypes()"
        [forbiddenFileTypes]="forbiddenFileTypes()"
        [disabled]="uploadDisabled()"
        [uploadStates]="fileStates()"
        (upload)="handleUpload($event)"
      ></sap-file-uploader>

      @if (parameterError()) {
        <p class="upload-status upload-status--error" role="alert">{{ parameterError() }}</p>
      }
    } @else {
      <p class="upload-status upload-status--error" role="alert">
        {{ 'errors.missingAggregateReference' | translate }}
      </p>
    }
  </div>
</section>
